import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useRegisterContext } from "../Contexts/RegisterContext";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";
import Button from "./Button";
import React from "react";

const PrivacyNoticeModal = ({ isOpen, onClose, toggleModal }) => {
  const { setTermsChecked, setShowPrivacyNoticeModal } = useRegisterContext();

  const handleClose = () => {
    setTermsChecked(true);
    setShowPrivacyNoticeModal(false);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className=" overflow-y-scroll sm:overflow-y-hidden"
    >
      <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
        <div className="w-full sm:w-148 flex-grow">
          <div className="sm:w-full bg-white rounded-xl sm:mt-14">
            <div className="w-full grid grid-cols-1 divide-y">
              <div className="m-4">
                <div className="grid justify-items-end">
                  <CloseIcon
                    className="cursor-pointer absolute"
                    onClick={onClose}
                    sx={{
                      width: "20px",
                      height: "20px",
                    }}
                  />
                </div>
                <div className=" font-bold text-center ">Privacy Notice</div>
              </div>

              <div>
                <div className="sm:h-96 overflow-y-scroll">
                  <div className="w-full p-4">
                    <div className="text-xs text-justify">
                      We, at Maxicare Healthcare Corporation (“Maxicare”), value
                      your privacy as much as we value your health. We are
                      committed to comply with Republic Act No. 10173 or the
                      Philippine Data Privacy Act of 2012 (“Data Privacy Act”),
                      its Implementing Rules and Regulations, and related
                      issuances from the National Privacy Commission, to protect
                      and safeguard your privacy.
                    </div>

                    <div className="mt-2 text-xs text-justify">
                      We periodically update this notice when necessary to
                      ensure that our practices remain compliant with the
                      applicable laws and are up to date with industry
                      standards.
                    </div>

                    <div className="mt-2 text-xs text-justify">
                      This notice will inform you how we process and protect
                      your personal information. By visiting this page or
                      reading this notice, you certify that you have read,
                      understood, and agree to the terms below.
                    </div>

                    <div className="mt-4">
                      <div className=" text-xs text-justify font-bold">
                        Service Overview
                      </div>

                      <div className=" mt-1 text-xs text-justify">
                        Maxicare is a Health Maintenance Organization (“HMO”),
                        which provides different healthcare services to our
                        members through our vast network of providers:
                        hospitals, clinics, physicians, diagnostic centers, and
                        other healthcare providers (collectively, “Providers”).
                        To effectively provide these services, our healthcare
                        providers may collect, process, and share your
                        information with us so that the healthcare services will
                        always be available when you need them most.
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className=" text-xs text-justify font-bold">
                        Purposes
                      </div>

                      <div className=" mt-2 text-xs text-justify">
                        We use your personal information for us to perform
                        transactions and functions necessary to implement and
                        administer your healthcare benefit from Maxicare. Your
                        personal information may also be used for reporting,
                        analysis and study purposes, and other functions
                        required or permitted by law.
                      </div>

                      <div className=" mt-2 text-xs text-justify">
                        We share your personal information to ensure that we can
                        provide you with the best and excellent healthcare
                        services that are readily available, as well as to
                        afford you a smoother and better customer experience. As
                        an example, we may outsource the maintenance of our
                        database and website, or we may share your information
                        with our affiliated hospitals, clinics, and physicians
                        with the objective of providing you immediate and
                        appropriate medical services. Rest assured that we only
                        share necessary information to our representatives (as
                        defined hereunder) in order to aid them in performing
                        their functions and to the extent permitted by law.
                      </div>

                      <div className="mt-2">
                        <div className="text-xs text-justify">
                          We collect your personal information for the following
                          purposes:
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">a. </span> Process,
                          review, and approve an application for enrollment,
                          employment, affiliation, and/or for coverage in any of
                          our products and/or services;
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">b. </span> Process orders
                          and availments for our products and/or HMO services,
                          reimbursements and/or claims, and online payments;
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">c. </span> Review and
                          approve the agents and/or brokers’ applications for
                          accreditation;
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">d. </span> Comply with
                          applicable laws of the Philippines, the laws on the
                          prevention of money laundering including the
                          provisions of Republic Act No. 9160 (Anti-Money
                          Laundering Act of 2001), as amended (AMLA) and the
                          implementation of “know-your-customer” requirements
                          and sanction screening checks;
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">e. </span> Conduct studies
                          and researches to review, develop, and improve our
                          products and services; and
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">f. </span> Perform profile
                          analysis, behavioral modeling, and analytics to
                          understand needs, preferences, and market trends to be
                          able to improve and recommend suitable products and
                          services.
                        </div>
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className=" text-xs font-bold text-justify">
                        Personal Information Collected and Processed
                      </div>

                      <div className="text-xs text-justify mt-2">
                        The information we collect and process shall include the
                        following:
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">a. </span> Personal contact
                        information: name, address, email address, phone number,
                        or any other information that would allow Maxicare to
                        contact you;
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">b. </span> Demographic
                        information: gender, date of birth, age, civil status,
                        etc.;
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">c. </span> Government-Issued
                        Identification: Social Security System (SSS) Number, Tax
                        Identification Number (TIN), Philippine Health Insurance
                        (PhilHealth) Number, Pag-IBIG (Home Development Mutual
                        Fund) Number, Passport Number, National Bureau of
                        Investigation (NBI) Clearance Number, etc.:
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">d. </span> Financial
                        information: bank details when you make payments for
                        your account, etc.;
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">e. </span> Medical history
                        and profile such as current medical condition, diagnosis
                        for ailments, medical orders, and records, etc.;
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">f. </span> Emergency
                        Contacts: name, address, telephone number;
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">g. </span> Professional
                        information (for medical affiliates and/or employees
                        with professional licenses applying to us);
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">h. </span> Non-personal
                        information such as those provided by your device which
                        may include the Internet Protocol (IP) address, your
                        geolocation, operating system, browser type and version,
                        and other machine identifiers, etc.; and
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">i. </span> Consumer
                        feedback, including the information that you share with
                        Maxicare such as your opinions or comments on our
                        products, and services, and voice recordings when you
                        reach us via our contact center;
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className=" text-xs text-justify font-bold">
                        Methods of Collection
                      </div>

                      <div className="mt-2 text-xs text-justify">
                        Where do we get your personal information?
                      </div>

                      <div className="mt-2 text-xs text-justify">
                        We collect your personal data from any documents or
                        communications that you may have directly submitted to
                        us, from publicly available information (including your
                        social media accounts), or from third parties,
                        including:
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">a. </span> When filling out
                        the application forms, agreements, and other similar or
                        related documents;
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">b. </span> When logging in
                        and using our website, mobile applications, and other
                        web-based platforms;
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">c. </span> When availing of
                        our product and services through our affiliate network;
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">d. </span> When getting in
                        touch with our customer service representatives to
                        inquire, file a complaint, or request for service/s;
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">e. </span> From your
                        employer as part of your medical and healthcare benefits
                        provided to you by your employer
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">f. </span> From the
                        principal member in case you are a dependent; and
                      </div>

                      <div className="mt-2 ml-4 text-xs text-justify">
                        <span className="font-bold">g. </span> In the course of
                        using our website and electronic platforms: Third Party
                        web analytics tools, including those of third parties,
                        that use cookies to collect anonymous information and
                        data generated in connection with your activities when
                        you visit the pages and our network of websites.
                      </div>

                      <div className="text-xs text-justify mt-2">
                        We also collect your personal information from other
                        sources that are commercially or publicly available such
                        as published directories and public documents. We may
                        also obtain your personal information from third parties
                        and other sources which have obtained your consent for
                        such disclosure or where it is lawfully permitted on our
                        part to acquire such information. Where you have
                        provided us with the personal data of individuals other
                        than yourself, you warrant that you have obtained their
                        consent for the disclosure, in accordance with the Data
                        Privacy Act.
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className=" text-xs font-bold text-justify">
                        Transfers/Disclosures
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        When and to whom do we disclose or share your personal
                        information?
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        In the course of providing services in accordance with
                        the agreement that you or your employer have entered
                        into with us, we normally engage the services of, and/or
                        interact with, third parties, such as, but not limited
                        to our parent company, affiliated companies,
                        subsidiaries, financial advisors, affiliated third
                        parties or independent/non-affiliated third parties and
                        service providers, whether local or foreign
                        (collectively referred to as “representatives”).
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        We may be required to disclose your personal information
                        with our representatives for any legitimate business
                        purpose as we may deem appropriate for your benefit,
                        including but not limited to outsourced processing of
                        our transactions, profiling, or historical statistical
                        analysis, and as necessary to provide you with our
                        services or for you to comply with your obligations in
                        accordance with the agreement that you or your employer
                        have entered into with us.
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        We will never share, sell or otherwise disclose your
                        personal information to third parties outside of our
                        Representatives except if you have given your consent.
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        Maxicare will ensure that in situations where your
                        information is shared, our representative shall comply
                        with the Data Privacy Act through technical or
                        organizational measures put in place.
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className=" text-xs font-bold text-justify">
                        Personal Information Controller
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        Maxicare is the Personal Information Controller of your
                        information, which means that it determines what
                        purposes personal information it holds will be used for.
                        By virtue thereof, your personal data may also be
                        disclosed to third parties pursuant to a data-sharing
                        agreement, in which case, such third parties are also
                        the personal information controllers of your personal
                        information.
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className=" text-xs font-bold text-justify">
                        Data Protection Measures
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        How do we protect your personal information?
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        We value your privacy, that is why we maintain, enforce,
                        and implement organizational, physical, technical,
                        electronic, and procedural security measures that ensure
                        the integrity, confidentiality, and security of your
                        personal information.
                      </div>

                      <div className="mt-2">
                        <div className=" text-xs text-justify">
                          We protect your information by implementing
                          safeguards, such as but not limited to the following:
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">a. </span> Access and use
                          your personal information only to the extent necessary
                          in order to administer the healthcare benefit;
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">b. </span> Use a secured
                          server maintained with firewall, encryption,
                          anti-virus, and other appropriate security controls;
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">c. </span> Restrict access
                          to your information to only authorized personnel who
                          will handle it with strict confidentiality;
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">d. </span> Undergo regular
                          audits internally by our audit team and third-party
                          auditors to ensure that your personal information is
                          secured and security controls are effective; Keep our
                          security systems up to date and conduct training and
                          seminars to our personnel in relation to protecting
                          your personal information;
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">e. </span> We have
                          confidentiality agreements with contracted parties
                          that receive, process, and store non-public personal,
                          health, and financial (when applicable) information
                          about you;
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">f. </span> We perform data
                          privacy and security assessment with contracted
                          parties to ensure that non-public personal, sensitive,
                          and privileged information are secured and appropriate
                          controls are enforced by the contracted parties; and
                        </div>

                        <div className="mt-2 ml-4 text-xs text-justify">
                          <span className="font-bold">g. </span> Other security,
                          organizational, and physical measures that we may
                          introduce in the future further strengthen the
                          protection and security of your personal information.
                        </div>

                        <div className=" text-xs mt-2 text-justify">
                          We keep your information in a secured facility within
                          the Philippines, and countries where Maxicare’s cloud
                          service providers reside for as long as necessary for
                          the fulfillment of the purposes for which the
                          information was obtained or for the establishment,
                          exercise, or defense of any claims arising from our
                          agreement with you or your employer, or as required or
                          permitted for by the law and regulations.
                        </div>
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className=" text-xs font-bold text-justify">
                        Data Retention
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        Your personal data will be retained or stored for as
                        long as the purposes for which they are being processed
                        subsist and/or have not been satisfied. We will retain
                        and use your personal information as necessary to comply
                        with our legal obligations, resolve disputes, and
                        enforce our agreements. Information provided to us shall
                        be disposed of or discarded in a secure manner that
                        would prevent further processing, unauthorized access,
                        or disclosure to any other party, or prejudice your
                        interest.
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className=" text-xs font-bold text-justify">
                        Data Subject Rights
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        In accordance with the Data Privacy Act, we uphold your
                        right in relation to your personal information. You have
                        the right to:
                      </div>

                      <div className=" text-xs mt-2 ml-4 text-justify">
                        • Be informed on the processing of your personal
                        information.
                      </div>

                      <div className=" text-xs mt-2 ml-4 text-justify">
                        • Request access to your personal information from our
                        systems and processes.
                      </div>

                      <div className=" text-xs mt-2 ml-4 text-justify">
                        • Object to our collection or processing of your
                        personal information.
                      </div>

                      <div className=" text-xs mt-2 ml-4 text-justify">
                        • Rectify, correct or modify your personal information.
                      </div>

                      <div className=" text-xs mt-2 ml-4 text-justify">
                        • Request the erasure or blocking of your personal
                        information from our systems and processes.
                      </div>

                      <div className=" text-xs mt-2 ml-4 text-justify">
                        • Request for a copy of your personal information and
                        transfer them securely to you for further use.
                      </div>

                      <div className=" text-xs mt-2 ml-4 text-justify">
                        • File a complaint if you believe that there was any
                        violation of your rights.
                      </div>

                      <div className=" text-xs mt-2 ml-4 text-justify">
                        • Be indemnified for the damages incurred based on a
                        final decision as a result of inaccurate, incomplete,
                        outdated, false, unlawfully obtained, erroneous data, or
                        unlawful processing of personal data.
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        You also have a choice to be included in our mailing
                        list whether for service, announcements, or sales and
                        marketing purposes. However, choosing or deciding to
                        remove your personal information from our systems may
                        limit our ability to provide excellent healthcare
                        services to you.
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className=" text-xs font-bold text-justify">
                        Maxicare Contact Information
                      </div>

                      <div className=" text-xs mt-2 text-justify">
                        If you have any inquiries, clarifications, and /or
                        concerns regarding your membership, our products and
                        services, and/or the updating of your personal
                        information, you may contact:
                      </div>

                      <div className="mt-2">
                        <div className=" text-xs font-bold text-justify ml-2">
                          24/7 Customer Care Hotline
                        </div>

                        <div className=" text-xs text-justify mt-1 ml-2">
                          <a
                            href="tel:+632 8582 1900"
                            target="_blank"
                            rel="noreferrer"
                            className="text-[#0947AB] font-semibold"
                          >
                            +632 8582 1900
                          </a>{" "}
                          <span>(PLDT)</span>
                        </div>

                        <div className=" text-xs text-justify mt-1 ml-2">
                          <a
                            href="tel:+632 7798 7777"
                            target="_blank"
                            rel="noreferrer"
                            className="text-[#0947AB] font-semibold"
                          >
                            +632 7798 7777
                          </a>{" "}
                          <span>(GLOBE)</span>
                        </div>

                        <div className=" text-xs text-justify mt-2 ml-2">
                          <span className="font-bold">Email Addres: </span>
                          <a
                            href="mailto:customercare@maxicare.com.ph"
                            target="_blank"
                            rel="noreferrer"
                            className="text-[#0947AB] font-semibold"
                          >
                            customercare@maxicare.com.ph
                          </a>
                        </div>

                        <div className="mt-4">
                          <div className=" text-xs text-justify ml-2 font-bold">
                            Sales Agent Concerns:
                          </div>

                          <div className="text-xs ml-2 mt-1">
                            <span className="font-bold">Email Addres: </span>
                            <a
                              href="mailto:partners.management@maxicare.com.ph"
                              target="_blank"
                              rel="noreferrer"
                              className="text-[#0947AB] font-semibold"
                            >
                              partners.management@maxicare.com.ph
                            </a>
                          </div>
                        </div>

                        <div className="mt-4">
                          <div className=" text-xs text-justify ml-2 font-bold">
                            Careers at Maxicare:
                          </div>

                          <div className="text-xs ml-2 mt-1">
                            <span className="font-bold">Email Addres: </span>
                            <a
                              href="mailto:talentacquisitionteam@maxicare.com.ph"
                              target="_blank"
                              rel="noreferrer"
                              className="text-[#0947AB] font-semibold"
                            >
                              talentacquisitionteam@maxicare.com.ph
                            </a>
                          </div>
                        </div>

                        <div className="mt-4">
                          <div className=" text-xs text-justify ml-2 font-bold">
                            Intermediary – Agents and Brokers Accreditation:
                          </div>

                          <div className="text-xs ml-2 mt-1">
                            <span className="font-bold">Email Addres: </span>
                            <a
                              href="mailto:accreditation@maxicare.com.ph"
                              target="_blank"
                              rel="noreferrer"
                              className="text-[#0947AB] font-semibold"
                            >
                              accreditation@maxicare.com.ph
                            </a>
                          </div>
                        </div>

                        <div className="mt-4">
                          <div className=" text-xs text-justify ml-2 font-bold">
                            Agent Commissions:
                          </div>

                          <div className="text-xs ml-2 mt-1">
                            <span className="font-bold">Email Addres: </span>
                            <a
                              href="mailto:commission@maxicare.com.ph"
                              target="_blank"
                              rel="noreferrer"
                              className="text-[#0947AB] font-semibold"
                            >
                              commission@maxicare.com.ph
                            </a>
                          </div>
                        </div>

                        <div className="mt-4">
                          <div className=" text-xs text-justify font-bold">
                            Data Privacy Team
                          </div>

                          <div className=" text-xs mt-2 text-justify">
                            If you have data privacy inquiries and concerns, or
                            you wish to report any violation of your data
                            privacy rights or to enforce any of your data
                            privacy rights, you may contact our Data Privacy
                            Officer through the following contact details:
                          </div>

                          <div className="mt-4">
                            <div className=" text-xs text-justify font-bold">
                              Data Protection Officer
                            </div>

                            <div className=" text-xs text-justify mt-1 ml-2">
                              <span className="font-bold">Tel #: </span>
                              <a
                                href="tel:+632 7908 6989"
                                className="text-[#0947AB] font-semibold"
                              >
                                +632 7908 6989
                              </a>
                            </div>

                            <div className="text-xs ml-2 mt-1">
                              <span className="font-bold">Email Addres: </span>
                              <a
                                href="mailto:dpo@maxicare.com.ph"
                                target="_blank"
                                rel="noreferrer"
                                className="text-[#0947AB] font-semibold"
                              >
                                dpo@maxicare.com.ph
                              </a>
                            </div>
                          </div>

                          <div className=" text-xs mt-4 text-justify italic">
                            Note: All non-data privacy-related emails sent to
                            this email address may not be responded to. Kindly
                            refer to the email addresses above for your specific
                            concerns or questions.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-4">
                  <div className="flex flex-row justify-center items-center mt-0">
                    <div>
                      <NavigateBeforeIcon
                        fontSize="large"
                        sx={{
                          cursor: "pointer",

                          color: "#A3A7AB",
                        }}
                        onClick={() => toggleModal("terms")}
                      />
                    </div>

                    <div>2</div>

                    <div>
                      <NavigateNextIcon
                        fontSize="large"
                        sx={{
                          color: "#EBEBE4",
                        }}
                      />
                    </div>
                  </div>
                  <div className="mt-2">
                    <Button className="w-full text-white" onClick={handleClose}>
                      I agree
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

PrivacyNoticeModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  toggleModal: PropTypes.any,
};

export default PrivacyNoticeModal;
